<template>
  <section class="dp-layout mr-page-layout">
    <section class="dp-right mr-module">
      <div class="page-header">
        <div>
          <div class="header-title-bar">
            <span class="header-icon-bar"></span>
            <h3>新校上线指引</h3>
          </div>
          <p class="page-desc">智能会议室后台初始化步骤与功能说明</p>
        </div>
        <el-tag v-if="schoolName" type="success" size="medium" effect="plain" class="school-badge">
          <i class="el-icon-school"></i> {{ schoolName }}
        </el-tag>
        <span v-else-if="!schoolId" class="school-hint">请在顶部选择学校</span>
      </div>

      <div v-if="!schoolId" class="empty-tip">请在顶部选择学校后查看指引</div>

      <el-card v-else shadow="never" class="config-card" v-loading="loading">
        <el-alert v-if="roomCount === 0" type="warning" :closable="false" show-icon
          title="当前学校尚未配置会议室，请按下方步骤完成初始化。" style="margin-bottom: 20px;" />
        <el-alert v-else type="success" :closable="false" show-icon
          :title="`当前已有 ${roomCount} 间会议室，可跳过配置步骤直接使用业务功能。`" style="margin-bottom: 20px;" />

        <el-steps :active="setupActiveStep" align-center finish-status="success" class="mr-setup-steps">
          <el-step v-for="(step, idx) in setupSteps" :key="idx"
            :title="step.title" :description="step.desc" />
        </el-steps>

        <div class="mr-setup-cards">
          <el-card v-for="(step, idx) in setupSteps" :key="step.path" shadow="never" class="mr-setup-card">
            <div class="mr-setup-card__num">{{ idx + 1 }}</div>
            <h4>{{ step.title }}</h4>
            <p>{{ step.detail }}</p>
            <el-button type="primary" size="small" @click="go(step.path)">前往配置</el-button>
          </el-card>
        </div>
      </el-card>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
import { BaseApiUrl } from '../../api/base';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';

const apiBase = BaseApiUrl;

export default {
  name: 'MeetingRoomGettingStarted',
  data() {
    return {
      loading: false,
      roomCount: 0,
      setupSteps: [
        {
          title: '会议室列表',
          desc: '新增会议室、绑班牌',
          detail: '维护会议室名称、开放时间、预约权限；绑定班牌终端；可下载门牌二维码。',
          path: '/MeetingRoom/RoomList'
        },
        {
          title: '审批流配置',
          desc: '需审批时配置流程',
          detail: '会议室开启「需要审批」后，在此配置审批链路与审批人。',
          path: '/MeetingRoom/MeetingApprovalProcess'
        },
        {
          title: '签到规则',
          desc: '签到宽限与提醒',
          detail: '配置提前签到分钟数、无人释放宽限、开始前提醒分钟数。',
          path: '/MeetingRoom/SchoolConfig'
        },
        {
          title: '会议列表',
          desc: '查看、审批、代订',
          detail: '全校会议记录；待审核 Tab 处理审批；页内可进入代订会议、日程看板代订、周期会议。',
          path: '/MeetingRoom/BookingList'
        }
      ]
    };
  },
  computed: {
    schoolId() {
      return resolveActiveSchoolId(this);
    },
    schoolName() {
      return this.$store.state.activeSchoolName || '';
    },
    setupActiveStep() {
      if (this.roomCount === 0) return 0;
      return this.setupSteps.length;
    }
  },
  watch: {
    schoolId(val, oldVal) {
      if (val !== oldVal) this.loadRoomCount();
    }
  },
  mounted() {
    if (this.schoolId) this.loadRoomCount();
  },
  methods: {
    loadRoomCount() {
      if (!this.schoolId) {
        this.roomCount = 0;
        return;
      }
      this.loading = true;
      axios.get(`${apiBase}/api/MeetingRoom/GetList`, {
        params: { page: 1, intPageSize: 1, departmentId: this.schoolId }
      }).then(res => {
        this.loading = false;
        this.roomCount = (res.data.success && res.data.response && res.data.response.dataCount) || 0;
      }).catch(() => {
        this.loading = false;
        this.roomCount = 0;
      });
    },
    go(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.mr-setup-steps {
  margin: 8px 0 28px;
}
.mr-setup-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  align-items: stretch;
}
.mr-setup-card {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid #e2e8f0;
  box-shadow: none !important;
}
.mr-setup-card >>> .el-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}
.mr-setup-card:hover {
  box-shadow: none !important;
}
.mr-setup-card h4 {
  margin: 0 0 8px;
  padding-right: 28px;
  font-size: 15px;
  color: #1e293b;
}
.mr-setup-card p {
  flex: 1;
  margin: 0 0 16px;
  font-size: 13px;
  line-height: 1.6;
  color: #64748b;
}
.mr-setup-card >>> .el-button {
  margin-top: auto;
  align-self: flex-start;
  min-width: 96px;
}
.mr-setup-card__num {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background: #eff6ff;
  color: #3b82f6;
  font-size: 12px;
  font-weight: 600;
}
</style>
